import { dataPvShieldSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPvShieldSolid = /*#__PURE__*/createIcon(dataPvShieldSolid)
export default IconPvShieldSolid
